import { updateProfileOtherInformation } from '@features/profile/api/update-profile-other-information/updateProfileOtherInformation';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateProfileOtherInformationRequest } from '../../api/update-profile-other-information/updateProfileOtherInformation.types';
import type { UseUpdateProfileOtherInformationResult } from './useUpdateProfileOtherInformation.types';

export function useUpdateProfileOtherInformation(): UseUpdateProfileOtherInformationResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateProfileOtherInformationRequest>({
    mutationFn: updateProfileOtherInformation,
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['client-profiles'] });
    },
  });
}
